exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root {\n  /* color */\n\n  /* font */\n\n  /* link */\n}\n:root {\n  /* цвет */\n\n  /* TODO в фигме другие цвета по названиям scarlet magenta green beeline aquamarine violet, надо решить с дизайнерами  */\n\n  /* токены со ссылкой на глобал цвета */\n\n  /* шрифт */\n\n  /* отступы от шапки и футера до тела страницы */\n\n  /* ширина тела страницы */\n\n  /* отступы между элементами страницы */\n}\n.NumbersListSection_wrapper_34Yn {\n  padding: 24px 0;\n}\n.NumbersListSection_list_2Q9q {\n  margin: 0;\n  padding: 12px 0 0 0;\n}\n.NumbersListSection_number_1pHo {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n\n  list-style-type: none\n}\n.NumbersListSection_number_1pHo:not(:last-child) {\n  padding-bottom: 8px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "NumbersListSection_wrapper_34Yn",
	"list": "NumbersListSection_list_2Q9q",
	"number": "NumbersListSection_number_1pHo"
};